import React from 'react'
import cx from 'classnames'
import { useSelector } from 'react-redux'
import Form from 'antd/lib/form'
import Checkbox from 'antd/lib/checkbox'
import Tooltip from 'antd/lib/tooltip'
import { RootState } from '@app-store/store'
import AladdinLampIcon from '@UI/LampIcon/LampIcon'
import styles from './index.scss'

type IProps = {
    name: string
    label?: string | React.ReactNode
    disabled?: boolean
    indeterminate?: boolean
    rules?: any
    mustCheck?: boolean
    onChange?: any
    tooltip?: string
    showLampTooltip?: boolean
    withForm?: boolean
}
const CheckboxField = (props: IProps) => {
    const {
        name,
        label,
        disabled = false,
        indeterminate = false,
        mustCheck = false,
        rules = [],
        tooltip = '',
        onChange,
        showLampTooltip,
        withForm = true
    } = props
    const { data: i18n } = useSelector((state: RootState) => state.localization.locals)
    const allRules = rules
    if (mustCheck) {
        allRules.push(() => ({
            validator(_, value) {
                if (value) {
                    return Promise.resolve()
                } else {
                    return Promise.reject(
                        i18n?.General?.You_need_agree_Terms_Privacy_Policy ||
                            'You need to agree with the Terms of Service and Privacy Policy'
                    )
                }
            }
        }))
    }
    const renderCheckbox = () => (
        <Checkbox disabled={disabled} indeterminate={indeterminate} onChange={onChange}>
            <span className={cx(styles.title, { [styles['must-check']]: mustCheck })}>
                {tooltip && !showLampTooltip ? (
                    <Tooltip placement="top" title={tooltip}>
                        {label}
                    </Tooltip>
                ) : (
                    <label>
                        {label}
                        {tooltip && showLampTooltip && (
                            <Tooltip title={tooltip}>
                                <AladdinLampIcon size={24} color="#FF681A" />
                            </Tooltip>
                        )}
                    </label>
                )}
            </span>
        </Checkbox>
    )
    return (
        <>
            {withForm ? (
                <Form.Item name={name} valuePropName="checked" className={styles.container} rules={allRules}>
                    {renderCheckbox()}
                </Form.Item>
            ) : (
                <div className={styles.container}>{renderCheckbox()}</div>
            )}
        </>
    )
}

export default CheckboxField
